import { useNavigate } from 'react-router-dom';
import Container from '../components/ui/Container/Container';
import PageHeading from '../components/ui/PageHeading/PageHeading';
import HeaderLinksList from '../components/Admin/HeaderLinks/HeaderLinksList';
import { Route } from '../routes';


const HeaderLinksPage: React.FC = () => {
  const navigate = useNavigate();

  const addHandler = () => {
    navigate(Route.headerLink("add"));
  }

  return (
    <>
    <PageHeading onAdd={addHandler} backTo={Route.settings}>Header Links</PageHeading>
    <Container>
      <HeaderLinksList />
    </Container>
    </>
  )
}

export default HeaderLinksPage;
